module.exports = __webpack_public_path__ + "h5/img/bs_08.42153a04.jpg";